import {
  Directive,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

import { catchError, first, firstValueFrom, map, throwError } from 'rxjs';

import { Store } from '@ngrx/store';

import { MasterFetchService } from '../../../fetches/services/master-fetch.service';
import { NgRxState } from '../../../modules/app-ngrx.module';
import { MasterAction } from '../../../stored/global/actions';
import { BankOptionModel } from '../../../models/common.model';

@Directive({
  selector: '[xbahtMasterPayoutMethod]',
})
export class MasterPayoutMethodDirective implements OnInit {
  constructor(
    private ngrxStore: Store<NgRxState>,
    private templateRef: TemplateRef<{
      $implicit: {
        id: string;
        name: string;
        description?: string | null;
        bank_options: BankOptionModel[];
      };
      index: number;
      first: boolean;
      last: boolean;
      even: boolean;
      odd: boolean;
      count: number;
    }>,
    private viewContainer: ViewContainerRef,
    private masterFetchService: MasterFetchService
  ) {}

  async ngOnInit(): Promise<void> {
    const payout_methods = await firstValueFrom(
      this.ngrxStore.select('Master').pipe(map((item) => item.payout_methods))
    );
    if (payout_methods.length != 0) {
      for (let index = 0; index < payout_methods.length; index++) {
        this.viewContainer.createEmbeddedView(this.templateRef, {
          $implicit: payout_methods[index],
          index,
          first: index === 0,
          last: index === payout_methods.length - 1,
          even: (index & 1) === 0,
          odd: (index & 1) === 1,
          count: payout_methods.length,
        });
      }
    } else {
      this.masterFetchService
        .payoutMethod({})
        .pipe(
          first(),
          catchError((error) => throwError(() => error))
        )
        .subscribe((item) => {
          if (item.status && item.payload) {
            this.ngrxStore.dispatch(
              MasterAction.SetPayoutMethod({ payout_methods: item.payload })
            );

            this.viewContainer.clear();
            for (let index = 0; index < item.payload.length; index++) {
              this.viewContainer.createEmbeddedView(this.templateRef, {
                $implicit: item.payload[index],
                index,
                first: index === 0,
                last: index === item.payload.length - 1,
                even: (index & 1) === 0,
                odd: (index & 1) === 1,
                count: item.payload?.length,
              });
            }
          }
        });
    }
  }
}
